var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-1 mb-0",staticStyle:{"font-family":"'ErbaumBook', sans-serif !important"}},[(_vm.title)?_c('div',[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.icon)?_c('v-icon',{attrs:{"large":!_vm.small,"right":""},domProps:{"textContent":_vm._s(_vm.mdiIcon)}}):_vm._e()],1):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }